const promises = []

export default {
  modules_link_converter() {
    return {
      linkConverter: {
        onLinkConverted: (link) => {
          this.onLinkConverted(link)
        },
      },
    }
  },

  onLinkConverted(link) {
    if (!link.raw) return

    promises.push(
      new Promise((resolve) => {
        this.pushEventTo(
          this.el.closest("form"),
          "handle_link",
          { link },
          (reply) => {
            this.quill.theme.modules.linkConverter.updateLink(reply.link)
            resolve()
          },
        )
      }),
    )
  },

  allLinksResolved() {
    return Promise.all(promises)
  },
}
